import React from "react";
import { Button, Card } from "flowbite-react";
import course1 from "../assets/course-1.webp";
import course2 from "../assets/course-2.webp";
import course3 from "../assets/course-3.webp";
import rotated from "../assets/rotated.webp";
import { HiArrowCircleRight } from "react-icons/hi";
import { Link } from "react-router-dom";

function Articles() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div>
      <div>
        <div
          style={{ backgroundImage: `url(${rotated})` }}
          className=" p-2 pb-5 bg-cover bg-center bg-no-repeat"
        >
          <div className="flex items-center mt-5">
            <div className="text-center mx-auto pt-5">
              <p className="mb-4 mt-10 pt-5 text-gray-500 font-medium ">
                LATEST ARTICLES
              </p>
              <h1 className="success-stories-heading ">
                Get News With UniThink
              </h1>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center pt-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 max-w-6xl mx-auto">
              <Card
                className="max-w-sm relative hover:scale-105 shadow-xl "
                imgSrc={course3}
              >
                <Link to="/blog1">
                  <Button
                    pill
                    gradientDuoTone="pinkToOrange"
                    onClick={scrollToTop}
                    outline
                    className="absolute top-48 right-2 z-1 border border-red-500 p-0 m-0"
                  >
                    <HiArrowCircleRight size={30} />
                  </Button>
                </Link>
                <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  How can you select the best courses to align with your future
                  career goals?
                </h5>
              </Card>
              <Card
                className="max-w-sm relative hover:scale-105 shadow-xl "
                imgSrc={course2}
              >
                <Link to="/blog2">
                  <Button
                    pill
                    gradientDuoTone="pinkToOrange"
                    onClick={scrollToTop}
                    outline
                    className="absolute top-48 right-2 z-1 border border-red-500 p-0 m-0"
                  >
                    <HiArrowCircleRight size={30} />
                  </Button>
                </Link>
                <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  How can career interest inventories help you decide on a
                  suitable career path?
                </h5>
                {/* <p className="font-normal text-gray-700 dark:text-gray-400">
                            Address concerns such as cultural adjustment, homesickness, language barriers, and academic differences, and discover strategies for overcoming these challenges.
                            </p> */}
              </Card>
              <Card
                className="max-w-sm relative hover:scale-105 shadow-xl "
                imgSrc={course1}
              >
                <Link to="/blog3">
                  <Button
                    pill
                    gradientDuoTone="pinkToOrange"
                    onClick={scrollToTop}
                    outline
                    className="absolute top-48 right-2 z-1 border border-red-500 p-0 m-0"
                  >
                    <HiArrowCircleRight size={30} />
                  </Button>
                </Link>
                <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  What are the Tips To Improve Your Career Development ?
                </h5>
                {/* <p className="font-normal text-gray-700 dark:text-gray-400">
                            Learn about resources such as international student advisors, language support, housing assistance, and student organizations offered by universities abroad.
                            </p> */}
              </Card>
            </div>
          </div>
          <Link to="/blogs">
            <Button
              outline
              size="lg"
              onClick={scrollToTop}
              gradientDuoTone="pinkToOrange"
              pill
              className="mx-auto justify-items-center mt-12 hover:scale-105"
              style={{ zIndex: 1, marginBottom: "60px" }}
            >
              Browse More Blogs <HiArrowCircleRight size={25} />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Articles;
